import {Component, Host, h, Element, State} from '@stencil/core';
import Splide from '@splidejs/splide'

@Component({
  tag: 'z3-slider',
  styleUrl: 'z3-slider.css',
  shadow: true,
})
export class Z3Slider {

  @Element() host: HTMLElement;

  splideElement!: HTMLDivElement;
  splideListElement!: HTMLElement;
  splideElementSlot!: HTMLSlotElement;

  @State() count: number = 0;
  @State() items: any = [];
  @State() splide: any = undefined;

  connectedCallback() {
    this.host.classList.add('load')
  }

  componentDidRender () {
    if (!this.splide && this.splideElement) {
      this.initSplide()
    }
  }

  initSplide() {
    let splide = new Splide(this.splideElement, {
      type      : 'slide',
    })
    this.splide = splide
    splide.on( 'overflow', function ( isOverflow ) {
      splide.go( 0 );
      splide.options = {
        arrows    : isOverflow,
        drag      : isOverflow,
        clones    : isOverflow ? undefined : 0,
        autoplay  : isOverflow,
      };
    });
    splide.mount();

    // Add items on slotChange to Slider
    this.host.shadowRoot.querySelector('slot').addEventListener('slotchange', () => {
      let slot = this.host.shadowRoot.querySelector('slot')
      let items = slot.assignedElements()
      this.items = items
      this.count = items.length
      items.forEach(item => {
        splide.add('<li class="splide__slide">' + item.outerHTML + '</li>');
      })
      splide.refresh();
    })
  }

  render() {
    return (
      <Host>
        <div class="splide" part="slide" ref={(el) => this.splideElement = el as HTMLDivElement}>
          <div class="splide__track" part="track">
            <ul class="splide__list" part="list" ref={(el) => this.splideListElement = el as HTMLElement}>
              <template>
                <slot ref={(el) => this.splideElementSlot = el as HTMLSlotElement}></slot>
              </template>
            </ul>
          </div>
          <div class="splide__arrows" part="arrows"></div>
          <div class="splide__progress" part="progress">
            <div class="splide__progress__bar"></div>
          </div>
        </div>
        <div class="sr-only">Image-Slider-with-{this.count}-Images</div>
      </Host>
    );
  }

}
